import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { ProjectsSaveMain } from '../elements-buttons/projects-save-btn';
import ListingShareBtn from '../elements-buttons/ListingShareBtn';
import { Helpers } from 'shared-components/helpers/helpers';

export class Lightbox extends React.Component {
  constructor (props) {
    super(props);
    this.openLightBox = this.openLightBox.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    const { listing, favoriteActionFn, isFav } = this.props;
    const fancyboxContainer = document.getElementById('fancybox-favorite');
    if (nextProps.isFav !== isFav) {
      if (fancyboxContainer) {
        ReactDOM.render(
          <ProjectsSaveMain
            isButton
            actionFn={favoriteActionFn}
            listing={listing}
            isFav={nextProps.isFav}
            hideCount
            unFavoriteText="Save"
            gaID={listing.ga_client_id}
            whichFavoriteBtn={'carousel top'}
          />, fancyboxContainer
        );
      }
    }
  }

  openLightBox () {
    analyticsIntegrations.carouselOpened(this.props.booking);
    const imgWidth = Helpers.isMobile() ? 'w_300' : 'w_1200';
    const { listing, hideFavButton, favoriteActionFn, hideBookingBtn, openShareModal } = this.props;
    const thisElement = this;
    $.fancybox.open(_.map(this.props.allImages, (image) => {
      return `https://img.peerspace.com/image/upload/c_crop,g_custom/${imgWidth},c_limit/g_auto,c_fill,f_auto,q_auto,dpr_2.0/l_pswm_gqnx1g,g_north_west,x_5,y_5,w_60,o_50/${image.external_id}`;
    }), {
      padding: 0,
      nextEffect: 'fade',
      prevEffect: 'fade',
      type: 'image',
      css: { 'background-color': '#ff0000' },
      closeClick: false,
      margin: [100, 60, 50, 60],
      tpl: {
        wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
        next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><div><span class="icon-image-arrows"></span></div></a>',
        prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><div><span class="icon-image-arrows"></span></div></a>'
      },
      index: this.props.index || 0,
      helpers: {
        title: {
          type: 'outside'
        },
        thumbs: {
          width: 80,
          height: 50,
          position: 'bottom'
        },
        overlay: {
          css: { background: 'rgba(0, 0, 0, .90)' },
          closeClick: false
        },
        buttons: {
          position: top,
          tpl: '<div id="fancybox-buttons" class="favorite-btn-container top"><div class="fancybox-btn-container"><div class="fancybox-btn-inner"><div id="fancybox-booking" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 col-sm-offset-2 col-md-offset-3 col-lg-offset-4 half-padding-right"></div><div id="fancybox-favorite" class="col-xs-6 col-sm-4 col-md-3 col-lg-2 half-padding-left"></div></div></div></div>'
        }
      },
      beforeShow () {
        const checkForOverlay = this.skin.parent().parent().hasClass('fancybox-overlay');
        const isMobile = this.skin.parent().hasClass('fancybox-mobile');
        const fancyboxHTML = $('html').hasClass('fancybox-html');
        // checking if fancybox has overlay and desktop version
        if (!checkForOverlay && !isMobile && !fancyboxHTML) {
          // add fancybox classes to html element
          $('html').addClass('fancybox-margin fancybox-lock fancybox-html');
          // wrap overlay to images if fancybox does not exist
          $('.fancybox-wrap').wrapAll('<div class="fancybox-overlay fancybox-overlay-fixed fancybox-override" />');
        }

        // Add overlay to fancybox if mobile
        if (isMobile) {
          const mobileEl = $('.fancybox-mobile')[0];
          const mobileOverlay = $(mobileEl).siblings().hasClass('fancybox-overlay');
          if (!mobileOverlay && !fancyboxHTML) {
            $('html').addClass('fancybox-margin fancybox-lock fancybox-html');
            $('.fancybox-mobile').after('<div class="fancybox-overlay fancybox-overlay-fixed fancybox-override" />');
          }
        }
      },
      afterShow () {
        if (0 === $('#fancybox-favorite').length && !hideFavButton) {
          setTimeout(() => {
            ReactDOM.render(
              <ProjectsSaveMain
                isButton
                actionFn={favoriteActionFn}
                listing={listing}
                isFav={thisElement.props.isFav}
                hideCount
                unFavoriteText="Save"
                gaID={listing.ga_client_id}
                whichFavoriteBtn={'carousel top'}
              />,
              document.getElementById('fancybox-favorite')
            );
          }, 200)
        }
        if (0 === $('#fancybox-booking').length && !hideBookingBtn) {
          setTimeout(() => {
            ReactDOM.render(
              <div className="lightbox-cta">
                <ListingShareBtn
                  buttonClass="favorites-btn share-btn flex center"
                  buttonText="Share"
                  listing={listing}
                  origin="share listing carousel"
                />
              </div>,
              document.getElementById('fancybox-booking')
            );
          }, 100);
        }
      },
      beforeClose () {
        // remove overlay overrides from fancybox;
        const htmlOverride = $('html').hasClass('fancybox-html');
        if (htmlOverride) {
          $('html').removeClass('fancybox-margin fancybox-lock fancybox-html');
          $('.fancybox-overlay').remove();
        }
      }
    });
    return false;
  }

  render () {
    return (
      <a className="open-fancybox" onClick={this.openLightBox}>
        {this.props.children}
      </a>
    );
  }
}

Lightbox.propTypes = {
  isFav: PropTypes.bool,
  listing: PropTypes.bool,
  hideFavButton: PropTypes.bool,
  favoriteActionFn: PropTypes.func,
  hideBookingBtn: PropTypes.bool,
  openShareModal: PropTypes.func,
  children: PropTypes.array,
  allImages: PropTypes.array
};
